import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GovukInitService } from '../../services/govuk-init.service';
import { ApiService } from "../../services/jrni/api.service";
import { AppConfig } from '../../app.config';
import { Router } from "@angular/router";
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear;
  sendingForm: UntypedFormGroup;
  private core = AppConfig.settings.core;
  showMessage = false;
  constructor(
    private govuk: GovukInitService,
    private apiService: ApiService,
    private router: Router
  ) {
    this.sendingForm = new UntypedFormGroup({
      message: new UntypedFormControl('', [Validators.required])
    });
  }

  async ngOnInit() {
    const _config: any = await this.apiService.getConfig(AppConfig.settings.core.company_id);
    this.showMessage = _config.journey_config.ceremonies.show_contact_form;

    this.govuk.init();
    this.currentYear = /\d{4}/.exec(Date())[0];
  }

  async sendMessage() {
    const message = this.sendingForm.controls['message'].value;
    await this.apiService.sendMessage(message);
    this.router.navigate(["/thankyou"]);
  }

  scrollToTop() {
    const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
    window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
  }

}
